import React, {useState} from 'react';
import {DEFAULT_MASTER_DATA_DASHBOARD_TAB, MASTER_DATA_DASHBOARD_TABS_LIST} from "../constants/master-data-constant";
import ShowTabsList from "../../common/ui/show-tabs-list";
import DimensionList from "./dimension/dimension-list";


const tabsList = MASTER_DATA_DASHBOARD_TABS_LIST;

const MasterDataDashboard = () => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_MASTER_DATA_DASHBOARD_TAB);

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start p-4 w-full">
                    <div className="flex justify-start m-2 pb-2">
                        <div className="text-xl">
                            Master Data
                        </div>
                    </div>


                    <div className="justify-center">

                        <div className="justify-start p-4">

                            <div>
                                <ShowTabsList
                                    setSelectedTab={setSelectedTab}
                                    selectedTab={selectedTab}
                                    tabsList={tabsList}/>
                            </div>

                            <div className="mt-4 px-4">

                                {selectedTab?.key === 'dimension' &&
                                    <div>
                                        <DimensionList/>
                                    </div>
                                }

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default MasterDataDashboard
